export const STORAGE_PREFIX = 'cached-data-';
export const BACK_URL = 'backUrl';
